import { type CreateShareSavingsAccountForChildProcess, ProcessStatus } from '@generated-types';

export const yearsOld = (age: number) => `${age} år`;

export const isComplete = ({ processStatus }: CreateShareSavingsAccountForChildProcess) =>
    processStatus === ProcessStatus.COMPLETED;

export const isWaitingForApproverParentConsent = ({ processStatus }: CreateShareSavingsAccountForChildProcess) =>
    processStatus === ProcessStatus.WAITING_FOR_APPROVER_PARENT_CONSENT;

export const hasPendingKYCConsent = ({ processStatus }: CreateShareSavingsAccountForChildProcess) =>
    processStatus === ProcessStatus.PENDING_KYC_CONSENT || processStatus === ProcessStatus.PENDING_KYC_ADVISOR_REVIEW;

export const approverParentHasConsented = (process: CreateShareSavingsAccountForChildProcess) =>
    process.processStatus === ProcessStatus.COMPLETED;

// Is based on your user's role in the process
export const getUserContextParentEmail = (process: CreateShareSavingsAccountForChildProcess) =>
    process.applicantParent.email ?? process.approverParent.email;
